// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import type { CareersOpeningOverview, CareersPage } from '../types';
import { createQueryKey } from '../utils/keys';

// ---------------------------------------------------------------
// Mutation Keys
// ---------------------------------------------------------------
export const patchCareersPageMutationKey = ['patchCareersPage'] as const;
export const postCareersPageSubdomainAvailableMutationKey = [
  'postCareersPageSubdomainAvailable',
] as const;

// ---------------------------------------------------------------
// Query Keys
// ---------------------------------------------------------------
export const getPublicCareersPageQueryKey = (subdomain: string) =>
  createQueryKey<CareersPage>()(['careers', subdomain] as const);

export const getPublicCareersOpeningsQueryKey = (subdomain: string) =>
  createQueryKey<CareersOpeningOverview[]>()([
    'careers',
    subdomain,
    'openings',
  ] as const);

export const getCareersPageQueryKey = (workspaceId: number) =>
  createQueryKey<CareersPage>()([
    'workspaces',
    workspaceId,
    'careers',
  ] as const);
